export const business = {
  name: "Arklis",
  siteUrl: import.meta.env.VITE_SITE_URL || "https://arklis.fr",
  phoneDisplay: "06 65 76 31 58",
  phoneHref: "+33665763158",
  publicEmail: "contact@arklis.fr",
  privacyEmail: "contact@arklis.fr",
  googleBusinessUrl: "https://share.google/R0prtTIIPTV9R5LlS",
  logoImage: "/assets/arklis-logo-20260713.png",
  faviconImage: "/favicon.png",
  searchIcon: "/icon-512.png",
  appleTouchIcon: "/apple-touch-icon.png",
  heroImage: "/assets/arklis-hero.png",
  squeegeeImage: "/assets/arklis-squeegee.png",
  areaName: "Val d'Europe",
  department: "Seine-et-Marne",
  serviceFrequency: "Hebdomadaire",
  acceptsCesu: true,
  cesuLabel: "Paiement CESU accepté",
  sapStatus: "Organisme déclaré Services à la Personne",
  sapDeclarationNumber: "",
  cities: [
    "Serris",
    "Chessy",
    "Montévrain",
    "Bailly-Romainvilliers",
    "Magny-le-Hongre",
    "Coupvray"
  ]
};
